import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Target, ArrowLeft } from "lucide-react";
import { childApi } from "../lib/api";

const STATUS_STYLE = {
  "Not Started": "bg-[#F3EFE0] text-[#566270]",
  "In Progress": "bg-[#F6EED8] text-[#8a6a10]",
  Completed: "bg-[#EBF6F0] text-[#2D6A4F]",
  Overdue: "bg-[#FBF0F2] text-[#A62B2B]",
};

export default function ChildQuests() {
  const [quests, setQuests] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    childApi.get("/child/quests").then((r) => setQuests(r.data.quests));
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF7EE]" data-testid="quests-page">
      <header className="bg-[#0B192C] text-[#FAF7EE] px-5 py-5">
        <div className="max-w-3xl mx-auto flex items-center gap-3">
          <button onClick={() => navigate("/play/home")} aria-label="Back" data-testid="back-btn"
            className="p-2.5 rounded-full hover:bg-white/10 min-h-[48px] min-w-[48px] flex items-center justify-center">
            <ArrowLeft className="w-5 h-5" />
          </button>
          <h1 className="font-display font-bold text-xl">My Quests</h1>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-5 py-8 space-y-4">
        {!quests ? null : quests.length === 0 ? (
          <p className="text-[#566270] text-sm" data-testid="no-quests">No Quests yet — your choir team will set one soon.</p>
        ) : quests.map((q) => (
          <div key={q.id} className="rounded-2xl bg-white border border-[#E5DEC9] p-5" data-testid={`quest-card-${q.id}`}>
            <div className="flex items-start justify-between gap-3">
              <div className="flex items-center gap-2">
                <Target className="w-4 h-4 text-[#7A1C2E] shrink-0" aria-hidden />
                <h2 className="font-display font-bold text-[#0B192C]">{q.title}</h2>
              </div>
              <span className={`text-[11px] font-bold px-2.5 py-1 rounded-full ${STATUS_STYLE[q.status]}`} data-testid={`quest-status-${q.id}`}>
                {q.status === "Overdue" ? "Still waiting for you" : q.status}
              </span>
            </div>
            {q.description && <p className="text-sm text-[#566270] mt-1.5">{q.description}</p>}
            <div className="mt-3">
              <div className="flex justify-between text-xs font-semibold text-[#566270]">
                <span>{Math.min(q.current, q.target)} / {q.target}</span>
                <span>Reward: {q.reward_notes} Notes</span>
              </div>
              <div className="h-2.5 rounded-full bg-[#F3EFE0] mt-1.5 overflow-hidden">
                <div className="h-full rounded-full bg-[#C69B3D] transition-all"
                  style={{ width: `${Math.min(100, (q.current / Math.max(1, q.target)) * 100)}%` }} />
              </div>
            </div>
            {q.deadline && (
              <p className="text-xs text-[#566270] mt-2">
                Finish by {new Date(q.deadline).toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long" })}
              </p>
            )}
          </div>
        ))}
        <Link to="/play/home" className="block text-center text-sm text-[#7A1C2E] font-semibold underline py-4" data-testid="back-home-link">
          Back to my home
        </Link>
      </main>
    </div>
  );
}
